module.exports = "/_next/static/images/74c04ee5eaa29d1fdde8b7d80b6ad8e1-usa.svg";